export default __webpack_public_path__ + "static/media/keller-card-sorting-main.c949504b.png";